<nz-form-control
  nzSpan="24"
  [nzErrorTip]="errorTemp"
  *ngIf="disabled !== true"
  class="generic-field"
>
  <!-- Relation Field -->
  <app-product-field-relation
    *ngIf="field.DataType === 8"
    [field]="field"
    [formGroup]="formGroup"
    [controlName]="controlName"
  >
  </app-product-field-relation>

  <nz-alert
    nzType="info"
    nzMessage="Media object can be saved only in Edit mode"
    *ngIf="
      record == null &&
      (field.DataType === 11 || field.DataType === 9 || field.DataType === 10)
    "
    nzShowIcon
  ></nz-alert>
  <!-- Gallery Field -->
  <app-extended-media-holder
    *ngIf="field.DataType === 11 && record != null"
    #mediaHolder
    [attributeType]="'gallery'"
    (fileRomoved)="markFormGroupDirty()"
    (fileUploaded)="markFormGroupDirty()"
    [ObjectType]="objectTypeId"
    [ObjectKey]="record.Id ?? record.id"
    [AttributeId]="field.Code"
  >
  </app-extended-media-holder>

  <!-- Image Field -->
  <app-extended-media-holder
    *ngIf="field.DataType === 9 && image && record != null"
    #mediaHolder
    [attributeType]="'image'"
    (fileRomoved)="markFormGroupDirty()"
    (fileUploaded)="markFormGroupDirty()"
    [ObjectType]="objectTypeId"
    [ObjectKey]="record.Id ?? record.id"
    [AttributeId]="field.Code"
  >
  </app-extended-media-holder>

  <!-- Vidoe Field -->
  <app-extended-media-holder
    *ngIf="field.DataType === 10 && image && record != null"
    #mediaHolder
    [attributeType]="'video'"
    (fileRomoved)="markFormGroupDirty()"
    (fileUploaded)="markFormGroupDirty()"
    [ObjectType]="objectTypeId"
    [ObjectKey]="record.Id ?? record.id"
    [AttributeId]="field.Code"
  >
  </app-extended-media-holder>

  <ng-container [formGroup]="formGroup">
    <!-- Time Field -->
    <app-product-field-time
      *ngIf="field.DataType === 3"
      [field]="field"
      [formControlName]="controlName"
      [formGroup]="formGroup"
      [controlName]="controlName"
      [languageId]="languageId"
      (onBlur)="onFieldValueChange($event)"
    >
    </app-product-field-time>

    <!-- Text Field -->
     <app-product-field-text
      *ngIf="field.DataType === 4"
      [field]="field"
      [formControlName]="controlName"
      [formGroup]="formGroup"
      [controlName]="controlName"
      [languageId]="languageId"
      (onBlur)="onFieldValueChange($event)"
    >
    </app-product-field-text>

    <!-- Normal string Field -->
     <app-product-field-string
      *ngIf="field.DataType === 1"
      [field]="field"
      [formControlName]="controlName"
      [formGroup]="formGroup"
      [controlName]="controlName"
      [languageId]="languageId"
      (onBlur)="onFieldValueChange($event)"
    >
    </app-product-field-string> 

    <!-- Dropdown Field -->
    <app-product-field-select
      *ngIf="field.DataType === 6"
      [field]="field"
      [formControlName]="controlName"
      [dropDownsMetaData]="dropDownsMetaData"
      [controlName]="controlName"
      [languageId]="languageId"
      [enableCreateOption]="enableCreateOption"
      (onBlur)="onFieldValueChange($event)"
    ></app-product-field-select>

    <!-- Date Field -->
    <app-product-field-date
      *ngIf="field.DataType === 2"
      [field]="field"
      [formControlName]="controlName"
      [controlName]="controlName"
      [languageId]="languageId"
      (onBlur)="onFieldValueChange($event)"
    >
    </app-product-field-date>

    <!-- Multiselect Field -->
    <app-product-field-multiselect
      *ngIf="field.DataType === 7"
      [field]="field"
      [formControlName]="controlName"
      [dropDownsMetaData]="dropDownsMetaData"
      [controlName]="controlName"
      [languageId]="languageId"
      [enableCreateOption]="enableCreateOption"
      (onBlur)="onFieldValueChange($event)"
    ></app-product-field-multiselect>

    <app-product-field-boolean
      *ngIf="field.DataType === 12"
      [field]="field"
      [dropDownsMetaData]="dropDownsMetaData"
      [controlName]="controlName"
      [formControlName]="controlName"
      [languageId]="languageId"
      (onBlur)="onFieldValueChange($event)"
    >
    </app-product-field-boolean>

    <!-- HTML Field -->
    <app-product-field-html
      *ngIf="field.DataType === 5"
      [field]="field"
      [formControlName]="controlName"
      [controlName]="controlName"
      [languageId]="languageId"
      (onBlur)="onFieldValueChange($event)"
    >
    </app-product-field-html>

    <!-- Number Field -->
    <app-product-field-number
      *ngIf="field.DataType === 0"
      [field]="field"
      [formControlName]="controlName"
      [controlName]="controlName"
      [languageId]="languageId"
      (onBlur)="onFieldValueChange($event)"
    >
      <ng-content select="#NumberContent"></ng-content>
    </app-product-field-number>
  </ng-container>
  <ng-template #errorTemp>
    <ng-container
      *ngIf="
      (field.Code.toString() | formControl : formGroup) != null &&
        (field.Code.toString() | formControl : formGroup).touched &&
        (field.Code.toString() | formControl : formGroup).invalid
      "
      >{{'This field is required' | translate}}</ng-container
    >
  </ng-template>
  <ng-container *ngIf="control?.errors != null">
    <p
      style="color: red"
      *ngFor="let error of control!.errors! | FieldValidator"
    >
      {{ error }}
    </p>
  </ng-container>
</nz-form-control>
